import { gql } from "graphql-request";
import { ImageSchema, ImageFragment } from "./image";
import { SysSchema, SysFragment } from "./sys";

import { z } from "zod";

export const CommunityCreatorSchema = z.object({
  sys: SysSchema,
  communityCreatorName: z.string().nullable(),
  communityCreatorId: z.string().nullable(),
  communityCreatorSubmissionInfo: z.string().nullable(),
  communityCreatorThumbnail: ImageSchema.nullable(),
  communityCreatorThumbnailEn: ImageSchema.nullable(),
});

export const CommunityCreator = CommunityCreatorSchema;
export type CommunityCreator = z.infer<typeof CommunityCreatorSchema>;

export const CommunityCreatorFragment = gql`
  fragment CommunityCreatorFragment on CommunityCreator {
    sys {
      ...SysFragment
    }

    communityCreatorName
    communityCreatorId
    communityCreatorSubmissionInfo
    communityCreatorThumbnail {
      ...ImageFragment
    }

    communityCreatorThumbnailEn: communityCreatorThumbnail(locale: "en") {
      ...ImageFragment
    }
  }

  ${ImageFragment}
  ${SysFragment}
`;
